/**
 * Capture a voucher code across the first-party sign-in flow.
 *
 * `/play?redeem=CODE` is the link a creator or a community post carries. The
 * code is bearer-like, so — exactly as `referral-link.ts` does for `?ref=` —
 * it is moved out of the address bar the moment it is seen: stashed in session
 * storage (this tab only) and stripped from the URL, so it never reaches a
 * screenshot, a copied link or a Referer header. Only `redeem` is removed;
 * `ref`, `listing`, `room` and the UTMs keep their own owners.
 *
 * The stored code outlives sign-up in the same tab and is cleared by the
 * voucher screens once the server has answered definitively.
 */
let MoonfallVoucherLink;

(function () {
  'use strict';

  const STORAGE_KEY = 'moonfall.pendingVoucherCode';
  const CODE_RE = /^[A-Za-z0-9-]{4,32}$/;

  function normalize(value) {
    if (typeof value !== 'string') return null;
    const trimmed = value.trim();
    return CODE_RE.test(trimmed) ? trimmed : null;
  }

  function getPendingCode() {
    try {
      return normalize(window.sessionStorage.getItem(STORAGE_KEY));
    } catch (_) {
      return null;
    }
  }

  function clearPendingCode(expectedCode) {
    const expected = normalize(expectedCode);
    if (!expected || getPendingCode() !== expected) return false;
    try {
      window.sessionStorage.removeItem(STORAGE_KEY);
      return true;
    } catch (_) {
      return false;
    }
  }

  function captureFromLocation() {
    let url;
    try {
      url = new URL(window.location.href);
    } catch (_) {
      return null;
    }
    const code = normalize(url.searchParams.get('redeem'));
    if (!code) return null;
    try {
      window.sessionStorage.setItem(STORAGE_KEY, code);
    } catch (_) {
      return null;
    }
    url.searchParams.delete('redeem');
    window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
    return code;
  }

  MoonfallVoucherLink = {
    STORAGE_KEY,
    captureFromLocation,
    clearPendingCode,
    getPendingCode,
  };
  captureFromLocation();
})();

export { MoonfallVoucherLink };
